import React, { useState } from 'react';
import { useStore } from '../store';
import { Globe, X, Check } from 'lucide-react';

export default function LanguageToggle() {
  const language = useStore((state) => state.language);
  const setLanguage = useStore((state) => state.setLanguage);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLanguageChange = (newLanguage: 'en' | 'fr') => {
    setLanguage(newLanguage);
    setIsModalOpen(false);
  };

  return (
    <>
      {/* Desktop: Keep the select dropdown */}
      <div className="hidden md:flex items-center gap-2">
        <Globe className="h-4 w-4 text-gray-500" />
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value as 'en' | 'fr')}
          className="text-sm border border-gray-300 rounded px-2 py-1 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          aria-label="Select language"
        >
          <option value="en">English</option>
          <option value="fr">Français</option>
        </select>
      </div>

      {/* Mobile: Button that opens modal */}
      <button
        onClick={() => setIsModalOpen(true)}
        className="md:hidden flex items-center gap-3 px-4 py-3 bg-white border-2 border-gray-300 rounded-lg w-full text-left hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Select language"
      >
        <Globe className="h-5 w-5 text-gray-500" />
        <span className="text-lg font-medium text-gray-700">
          {language === 'en' ? 'English' : 'Français'}
        </span>
      </button>

      {/* Modal for mobile */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 md:hidden">
          <div className="bg-white rounded-lg max-w-sm w-full p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold flex items-center gap-2">
                <Globe className="h-5 w-5" />
                Language
              </h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-400 hover:text-gray-500"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="space-y-3">
              <button
                onClick={() => handleLanguageChange('en')}
                className={`w-full flex items-center justify-between p-4 rounded-lg border-2 transition-colors ${
                  language === 'en'
                    ? 'border-blue-500 bg-blue-50 text-blue-700'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <span className="text-lg font-medium">English</span>
                {language === 'en' && <Check className="h-5 w-5" />}
              </button>

              <button
                onClick={() => handleLanguageChange('fr')}
                className={`w-full flex items-center justify-between p-4 rounded-lg border-2 transition-colors ${
                  language === 'fr'
                    ? 'border-blue-500 bg-blue-50 text-blue-700'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <span className="text-lg font-medium">Français</span>
                {language === 'fr' && <Check className="h-5 w-5" />}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}